import { ClipSceneConfig } from '.'
import { DEFAULT_WORDS } from './defaultSubtitles'
import { THEMES } from './themes'

export const defaultClipScene = {
  kind: 'clip',
  duration: 30,
  mediaUrl:
    'https://storage.googleapis.com/zealous-rooms.appspot.com/recordings%2Fmtg_2Gs7UQ5tSs3aVdVVdcwGrBYD7as%2F1PlKQpnjvpVxE-utt_2Gs7WbgEIKf0Rw95lB3eNqqoyx2-clip.m4a',
  layout: 'avatar',
  paragraphs: [
    {
      start: 0,
      end: 30,
      speaker: {
        avatarUrl:
          'https://pbs.twimg.com/profile_images/1746332567467364352/PJCQcUip_400x400.jpg',
        name: 'Gregarious',
        role: 'HOST',
        speakingTime: 300,
        username: '@gregarious',
      },
    },
  ],
  words: DEFAULT_WORDS,
  theme: THEMES[0]!.config,
  title: 'Audiograms, Audiograms, Audiograms',
  subtitle: 'Hosted by Zealous',
  imageUrl: 'https://picsum.photos/seed/clip-avatar/400/400',
  showZealousLogo: true,
} satisfies ClipSceneConfig
